import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TRemoteBuildAndPriceFields,
  TRemoteBuildAndPriceProps,
} from '../types/remoteBuildAndPrice.types';
import buildAndPriceLinkEnvMap from '../../../constants/buildAndPriceLinkEnvMap.constants.json';

export class BuildAndPriceLinkModel {
  readonly fields?: TRemoteBuildAndPriceFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TRemoteBuildAndPriceProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get basePath(): string {
    return (
      buildAndPriceLinkEnvMap[process.env.REACT_APP_BUILD_AND_PRICE_ENV || ''] ||
      buildAndPriceLinkEnvMap['PROD']
    );
  }

  get division(): string {
    return this.fields?.division?.value || '';
  }

  get locale(): string | undefined {
    return this.fields?.locale?.value || undefined;
  }

  get language(): string | undefined {
    return this.fields?.language?.value || undefined;
  }

  get sapNumber(): number | undefined {
    return this.fields?.sapNumber?.value || undefined;
  }

  get vhsar(): string {
    return this.fields?.vhsar?.value || '';
  }

  get vkorg(): string | undefined {
    return this.fields?.vkorg?.value || undefined;
  }

  get geographicArea(): string {
    return this.fields?.geographicArea?.value || '';
  }

  get disableDLM(): boolean{
    return !!this.fields?.disableDLM?.value;
  }

}
